var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultImg = function SvgDefaultImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "#16171A",
    rx: 12.224
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.282 205.512h-9.302v-22.223h8.926c4.338 0 6.867 2.435 6.867 6.242 0 2.467-1.622 4.057-2.745 4.588 1.344.625 3.059 2.03 3.059 4.996 0 4.15-2.843 6.397-6.805 6.397m-.719-18.354h-4.245v5.122h4.245c1.842 0 2.872-1.029 2.872-2.561 0-1.528-1.03-2.561-2.872-2.561m.282 9.024h-4.527v5.461h4.527c1.964 0 2.904-1.25 2.904-2.745 0-1.499-.94-2.716-2.904-2.716M178.319 196.398v9.114h-4.305v-9.114l-6.68-13.109h4.715l4.15 8.959 4.089-8.959h4.71zM197.299 205.512h-9.302v-22.223h8.926c4.338 0 6.867 2.435 6.867 6.242 0 2.467-1.622 4.057-2.745 4.588 1.344.625 3.059 2.03 3.059 4.996 0 4.15-2.843 6.397-6.805 6.397m-.719-18.354h-4.245v5.122h4.245c1.842 0 2.872-1.029 2.872-2.561 0-1.528-1.03-2.561-2.872-2.561m.282 9.024h-4.527v5.461h4.527c1.965 0 2.904-1.25 2.904-2.745-.004-1.499-.939-2.716-2.904-2.716"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M213.185 176.484h-4.338v22.223h4.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227.168 187.158v18.354h-4.339v-18.354h-5.805v-3.869h15.949v3.869z"
  }))));
};
export default SvgDefaultImg;